import { useMemo } from 'react';
import { FAST_USER_INTERACTION_DEBOUNCE } from '../../../../constants';
import { useDebouncedValue } from '../../../../hooks/useDebounceValue';
import { useHannibalQuery } from '../../../../schema/hannibal/HannibalContext';
import {
  SuggestionTreatmentFragment,
  TreatmentSuggestionsDocument,
} from '../../../../schema/hannibal/types.generated';
import { EMPTY_LIST } from '../../../../util/EMPTY_LIST';
import { parseToEnum } from '../../../../util/parseToEnum';
import { CountryState } from '../../constants';
import { SuggestionTreatmentProfile } from './SuggestionTreatmentProfile';

export const mapSuggestedProfilesToSuggestionTreatmentProfiles = (
  profiles: readonly SuggestionTreatmentFragment[],
): SuggestionTreatmentProfile[] =>
  profiles.flatMap(it => {
    if (it.__typename !== 'Practice' || !it.address) return [];
    const { suburb, state: rawState, postcode } = it.address;
    const state = parseToEnum(rawState, CountryState);
    const { interests, procedures } = it;

    return {
      suburb,
      state,
      postcode,
      interests: interests.map(it => it.name),
      procedures: procedures.map(it => it.name),
    };
  });

export const useSuggestedProfiles = (searchTerm: string): SuggestionTreatmentProfile[] => {
  const query = useDebouncedValue(searchTerm, FAST_USER_INTERACTION_DEBOUNCE);
  const queryResult = useHannibalQuery(TreatmentSuggestionsDocument, { variables: { query } });

  const profiles = queryResult.data?.searchText.profiles ?? EMPTY_LIST;

  return useMemo(() => mapSuggestedProfilesToSuggestionTreatmentProfiles(profiles), [profiles]);
};
